// extracted by mini-css-extract-plugin
module.exports = {"modalHeader":"Modal_modalHeader__10PAz","modalBody":"Modal_modalBody__2xFk2","useMacFix":"Modal_useMacFix__15ihl","modalContent":"Modal_modalContent__3gAr-"};